<template>
    <div>
        <v-flex pl-2 class="speaker-resource">
            <v-layout
                row
                wrap
                v-if="pendingApplicants"
                class="speaker-resource__applicants__header">
                <v-flex xs12 sm9>
                    <v-flex tag="h2">{{SpeakerApplicants.PENDING_APPLICANTS}}</v-flex>
                </v-flex>
                <v-flex
                    xs12
                    sm3
                    v-if="pendingApplicantsCount"
                    text-sm-right>
                    <v-flex tag="span" data-qe-id="pending_count"> {{pendingApplicantsCount}} {{SpeakerApplicants.PENDING_REQUESTS}}</v-flex>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex lg12 xs12>
                    <v-flex class="speaker-resource__applicants relative-position">
                        <status-overlay v-if="pendingApplicants && !pendingApplicants.length"
                                        :action="loadingAction"
                                        content-height="400px"></status-overlay>
                        <v-flex class="applicants-list">
                            <div v-infinite-scroll="getInfinitePendingApplicants"
                                 :infinite-scroll-distance="2000">
                                <v-layout
                                    row
                                    wrap
                                    class="applicants-list__row"
                                    v-for="(pendingApplicant, j) in pendingApplicants"
                                    :key="j">
                                    <v-flex
                                        xs12
                                        sm8
                                        md9
                                        class="user-info pointer"
                                        :data-qe-id="`pending_applicant${j}`"
                                        :id="`id_${pendingApplicant.speakerType === 'Non-Member' ? pendingApplicant.speakerId : pendingApplicant.personID}`"
                                        @click="openPendingSpeakerProfile(pendingApplicant)">
                                        <img :key="pendingApplicant.profileImageUrl" :src="pendingApplicant.profileImageUrl === null ? pendingApplicant.fallbackProfileImageUrl : pendingApplicant.profileImageUrl " :data-qe-id="`speaker-pending-applicants-${j}_profile-image`" :onerror="imageErrorFallback(pendingApplicant.fallbackProfileImageUrl)" />
                                        <strong :data-qe-id="`first_last_name${j}`">{{pendingApplicant.firstName}} {{pendingApplicant.familyName}}</strong>
                                        <small :data-qe-id="`travels_from${j}`">Travels from: {{pendingApplicant.travelFromCity}}, {{pendingApplicant.country}}</small>
                                        <span :data-qe-id="`fees${j}`">Fees: <em>{{pendingApplicant.feeRange}}</em></span>
                                        <span :data-qe-id="`categories${j}`"> {{SpeakerApplicants.CATEGORIES}} <em :data-qe-id="`categories_first${j}`">{{pendingApplicant.categories[0]}}</em> <em :data-qe-id="`categories_count${j}`" class="pl-2" v-if="pendingApplicant.categories.length >1">{{`+${pendingApplicant.categories.length-1}`}} </em> </span>
                                    </v-flex>
                                    <v-flex
                                        xs12
                                        sm4
                                        md3
                                        class="user-status">
                                        <v-select
                                            :data-qe-id="`{approve_deny_select${j}`"
                                            v-model="pendingApplicant.selectedStatus"
                                            :items="SpeakerApplicants.PENDING_STATUS_ITEMS"
                                            :label="SpeakerApplicants.APPROVE_DENY"
                                            flat
                                            hide-details
                                            v-on:change="openStatusChange(pendingApplicant.selectedStatus, pendingApplicant)"
                                            solo></v-select>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-flex>
                    </v-flex>
                </v-flex>
            </v-layout>

            <v-dialog
                v-model="openDenyConfPopup"
                lazy
                absolute
                content-class="extra-small"
                persistent>
                <v-card class="custom-dailog">
                    <v-card-title>
                        Confirm
                        <i class="fas fa-times" @click="cancelDialog()" data-qe-id="close_dialog_btn"></i>
                    </v-card-title>
                    <v-card-text>
                        <v-flex tag="p">{{popupMessage}}</v-flex>
                    </v-card-text>

                    <v-card-actions>
                        <v-flex text-xs-right class="px-3 py-2">
                            <v-btn
                                class="primary_btn transparent"
                                @click="cancelDialog()"
                                data-qe-id="cancel_dialog_btn">
                                Cancel
                            </v-btn>
                            <v-btn
                                :loading="isSubmitting"
                                class="primary_btn"
                                @click="confirmToAction()"
                                data-qe-id="save_dialog_btn">{{ApproveDeny}}</v-btn>
                        </v-flex>
                    </v-card-actions>

                </v-card>
            </v-dialog>
        </v-flex>
        <BackToTop></BackToTop>
    </div>
</template>

<script>
    import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import { imageErrorFallback } from "../../common/utils/utils";
    import { SpeakerApplicants } from "../Speakers/speakerConstant";
    import BackToTop from '../../components/Layout/BackToTop';
    import StatusOverlay from "../StatusOverlay/StatusOverlay";

    export default {
        name: "SpeakerResource",
        data: () => ({
            SpeakerApplicants,
            openDenyConfPopup: false,
            actionApplicantObj: {
                SpeakerId: "",
                ApprovalStatus: "R",
                FirstName: "",
                Email: "",
                SpeakerType: "",
            },
            currentDenyApproveItem: SpeakerApplicants.APPROVE_DENY,
            isSubmitting: false,
            popupMessage: '',
            ApproveDeny: '',
        }),
        components: {
            StatusOverlay,
            BackToTop,
        },
        created() {
            this.resetPendingApplicantsList();
            this.getPendingApplicants();
            this.getPendingApplicantsCount();
        },
        mounted() {
            if (this.scrollPendingApplicantToViewMember) {
                this.$vuetify.goTo(`#id_${this.scrollPendingApplicantToViewMember}`, { offset: 250, easing: 'easeInOutCubic', duration: 300 });
                this.setScrollPendingApplicantToViewMember(null);
            }
        },
        methods: {
            ...mapActions({
                getPendingApplicants: `speaker/${storeAction.getPendingApplicants}`,
                getPendingApplicantsCount: `speaker/${storeAction.getPendingApplicantsCount}`,
                getRejectApplicant: `speaker/${storeAction.getRejectApplicant}`,
                getApproveApplicant: `speaker/${storeAction.getApproveApplicant}`,
            }),
            ...mapMutations({
                resetPendingApplicantsList: `speaker/${storeMutation.resetPendingApplicantsList}`,    
                setScrollPendingApplicantToViewMember: `speaker/${storeMutation.setScrollPendingApplicantToViewMember}`,    
                setCurrentlyViewingPendingOrReviewApplicantRecord: `speaker/${storeMutation.setCurrentlyViewingPendingOrReviewApplicantRecord}`,            
            }),
            imageErrorFallback,
            getInfinitePendingApplicants() {
                if (!this.disablePAInfiniteScroll && !this.noMorePendingApplicantsToFetch) {
                    this.getPendingApplicants();
                }
            },
            openStatusChange(paStatus, pendingApplicantObj) {
                this.currentDenyApproveItem = pendingApplicantObj;
                this.settingBackValue = pendingApplicantObj.settingBackValue;
                this.actionApplicantObj = {
                    SpeakerId: pendingApplicantObj.speakerId,
                    ApprovalStatus: "",
                    FirstName: pendingApplicantObj.emailFirstName,
                    Email: pendingApplicantObj.email,
                    SpeakerType: pendingApplicantObj.speakerType,
                };
                if (paStatus === SpeakerApplicants.PENDING_STATUS_ITEMS[0]) {
                    this.popupMessage = SpeakerApplicants.ARE_YOU_SURE_WANT_TO_APPROVE_THE_APPLICANT;
                    this.actionApplicantObj.ApprovalStatus = "A";
                    this.openDenyConfPopup = true;
                    this.ApproveDeny = "Approve";
                } else if (paStatus === SpeakerApplicants.PENDING_STATUS_ITEMS[1]) {
                    this.popupMessage = SpeakerApplicants.ARE_YOU_SURE_WANT_TO_DENY_THE_APPLICANT;
                    this.actionApplicantObj.ApprovalStatus = "R";
                    this.ApproveDeny = "Deny";
                    this.openDenyConfPopup = true;
                }
            },
            cancelDialog() {
                this.openDenyConfPopup = false;
                this.currentDenyApproveItem.selectedStatus = null;
            },
            confirmToAction() {
                this.isSubmitting = true;
                if (this.actionApplicantObj.ApprovalStatus === "A") {
                    this.getApproveApplicant(this.actionApplicantObj).then(() => {
                        const applicantIndex = this.pendingApplicants.findIndex(item => item.speakerId === this.actionApplicantObj.SpeakerId);
                        this.pendingApplicants.splice(applicantIndex, 1);
                        this.refreshPageMethods();
                        this.isSubmitting = false;
                    });
                } else if (this.actionApplicantObj.ApprovalStatus === "R") {
                    this.getRejectApplicant(this.actionApplicantObj).then(() => {
                        this.pendingApplicants.splice(this.pendingApplicants.map(e => e.speakerId).indexOf(this.actionApplicantObj.SpeakerId), 1);
                        this.refreshPageMethods();
                        this.isSubmitting = false;
                    });
                }
            },
            refreshPageMethods() {
                this.getPendingApplicants();
                this.getPendingApplicantsCount();
                this.openDenyConfPopup = false;
            },
            openPendingSpeakerProfile(pendingApplicant) {
                const speakerType = pendingApplicant.speakerType === 'Non-Member' ? 'speaker' : 'member';
                const id = pendingApplicant.speakerType === "Non-Member" ? pendingApplicant.speakerId : pendingApplicant.personID;
                sessionStorage.setItem(SpeakerApplicants.SPEAKER_TYPE, speakerType);
                sessionStorage.setItem(SpeakerApplicants.PREVIOUS_PAGE, 'Pending');
                sessionStorage.setItem(SpeakerApplicants.SPEAKER_STATUS, pendingApplicant.approvalStatus || 'P'); 
                this.setCurrentlyViewingPendingOrReviewApplicantRecord({ recordType: 'pending', speakerType, id });
                this.$router.push({
                    path: `/speakerPage/speakerProfile`,
                    query: {
                        id,
                    },
                });
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                pendingApplicants: `speaker/${storeGetters.pendingApplicants}`,
                pendingApplicantsCount: `speaker/${storeGetters.pendingApplicantsCount}`,
                disablePAInfiniteScroll: `speaker/${storeGetters.disablePAInfiniteScroll}`,
                noMorePendingApplicantsToFetch: `speaker/${storeGetters.noMorePendingApplicantsToFetch}`,
                rejectApplicant: `speaker/${storeGetters.rejectApplicant}`,
                approveApplicant: `speaker/${storeGetters.approveApplicant}`,
                scrollPendingApplicantToViewMember: `speaker/${storeGetters.scrollPendingApplicantToViewMember}`,
            }),
            loadingAction() {
                return this.actions[storeAction.getPendingApplicants];
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .speaker-resource {
        &__options {
            &__row {
                border-bottom: 1px solid rgba($ypo-gray, 0.4);
                padding: 15px;
                position: relative;
                color: $ypo-blue;
                cursor: pointer;
                transition: all .3s ease;

                i {
                    font-size: 20px;
                    margin-right: 5px;
                }

                &:hover {
                    background: rgba($ypo-gray, 0.1);
                    text-shadow: 0 1px $ypo-blue;
                }
            }
        }

        &__applicants {
            position: relative;

            &__header {
                padding: 15px 0;
                border-bottom: 1px solid rgba($ypo-gray, 0.4);
                align-items: center;
                color: $ypo-blue;

                h2 {
                    font-family: 'Raleway', sans-serif;
                    font-size: 18px;
                    font-weight: 500;
                }

                span {
                    font-size: 14px;
                }
            }
        }

        .applicants-list {
            &__row {
                padding: 15px 10px;
                border-bottom: 1px solid rgba($ypo-gray, 0.4);
                align-items: center;
                transition: all .3s ease;

                &:hover {
                    background-color: rgba($ypo-gray, 0.1);
                }

                .user-info {
                    position: relative;
                    padding-left: 80px;
                    color: $ypo-blue;
                    font-size: 10px;

                    img {
                        width: 70px;
                        height: 70px;
                        position: absolute;
                        left: 0;
                        object-fit: contain;
                    }

                    strong {
                        display: block;
                        color: $ypo-dark-background-gray;
                        font-size: 16px;
                    }

                    small {
                        display: block;
                        font-size: 10px;
                        font-weight: bold;
                    }

                    span {
                        display: block;
                        font-weight: 600;

                        em {
                            font-style: normal;
                            color: $ypo-dark-background-gray;
                        }
                    }
                }

            }
        }

        @include breakpoint(md) {
            .applicants-list {
                .user-status {
                    padding-left: 0;
                }
            }
        }

        @include breakpoint(sm) {
            padding-left: 0 !important;

            .applicants-list {
                .user-status {
                    padding-left: 45px;
                }
            }

            .speaker-applicants-xs {
                padding-left: 0 !important;
            }
        }

        @include breakpoint(xs) {
            margin: 10px 10px 40px 10px;

            .applicants-list {
                .user-status {
                    padding-left: 160px;
                }
            }

            &__applicants {
                .speaker-resource {
                    margin: 0;
                }
            }
        }
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .speaker-resource {
        .applicants-list {
            &__row {
                .user-status {
                    padding-left: 30px;

                    .v-input__slot {
                        margin-bottom: 0;

                        .v-label {
                            color: $ypo-gray-text;
                        }

                        .v-icon {
                            color: $ypo-cta;
                            font-size: 30px;
                        }
                    }
                }
            }
        }

    }
</style>
